module.exports = __webpack_public_path__ + "img/logo_wolk.2c4b7249.jpg";